module.exports = __webpack_public_path__ + "img/warning.9ccb4d95.svg";